import React, { useState } from "react";
import AzureAuthenticationContext from "src/azure/azure-authentication-context";
import { AccountInfo } from "@azure/msal-browser";
import AzureAuthenticationRedirectContext from "./azure-authentication-redirect-context";
import LogoMicrosoft from "src/assets/images/logoMicrosoft.svg";
import styled from "styled-components";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const chrome = ua.indexOf("chrome");
const isIE = msie > 0 || msie11 > 0;

// Log In, Log Out button

const AzureAuthenticationButton = ({ onAuthenticated }: any): JSX.Element => {
  // Azure client context
  const authenticationModule: AzureAuthenticationContext = new AzureAuthenticationContext();
  const authenticationRedirectModule: AzureAuthenticationRedirectContext = new AzureAuthenticationRedirectContext();

  // const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<AccountInfo>();
  // const [token, setToken] = useState<string>();

  const logIn = (method: string): any => {
    // const typeName = "loginPopup";
    // const typeName = "loginRedirect";
    // const logInType = isIE ? "loginRedirect" : typeName;
    const logInType = method;
    // const logInType = "loginRedirect";
    // Azure Login
    // authenticationModule.login(logInType, returnedAccountInfo);
    const result = authenticationRedirectModule.login(returnToken);
  };

  // 사용 안함
  const logOut = (): any => {
    if (user) {
      onAuthenticated(undefined);
      // Azure Logout
      authenticationModule.logout(user);
    }
  };

  // const returnedAccountInfo = (user: AccountInfo) => {
  //   // set state
  //   setAuthenticated(user?.name ? true : false);
  //   onAuthenticated(user);
  //   setUser(user);
  // };

  const returnToken = (token: string) => {
    // setAuthenticated(token ? true : false);
    onAuthenticated(token);
    // setToken(token);
  };

  const showLogInButton = (): any => {
    return (
      //loginRedirect / loginPopup
      <div id="authenticationButton" className="ms-logo" onClick={() => logIn("loginRedirect")}>
        {/* 본사 MS 로그인 */}
      </div>
    );
  };

  const showLogOutButton = (): any => {
    return (
      <div id="authenticationButtonDiv">
        <div id="authentication">
          <div id="authenticationButton" onClick={() => logOut()}></div>
        </div>
      </div>
    );
  };

  const showButton = (): any => {
    // return authenticated ? showLogOutButton() : showLogInButton();
    return showLogInButton();
  };

  return (
    <MsLoginBtn id="authentication">
      {authenticationModule.isAuthenticationConfigured ? showButton() : <div>Authentication Client ID is not configured.</div>}
    </MsLoginBtn>
  );
};

const MsLoginBtn = styled.div`
  width: 100%;
  height: 100%;
  > .ms-logo {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: url(${LogoMicrosoft}) no-repeat center center;
    background-size: 110px 24px;
  }
`;

export default AzureAuthenticationButton;
